import { SCRIPT } from "callable-data-objects";
import { get as getWidget } from "Components/Device/Flow/constants";
import ConnectTo from "Components/Device/Forms/ConnectTo";
import General from "Components/Device/Forms/General";
import ScriptForm from "Components/Device/Script/ScriptForm";
import DeleteForm from "Components/Shared/DeleteForm";
import React, { useState } from "react";
import { Grid, Icon, Menu } from "semantic-ui-react";

const Script = () => {
  const [activeMenu, setActiveMenu] = useState<string | undefined>("connectTo");
  const widget = getWidget(SCRIPT);
  return (
    <Grid stackable columns={2}>
      <Grid.Column width={3}>
        <Menu vertical fluid pointing size='small'>
          <Menu.Item header>
            <Icon name={widget.icon} color={widget.color} />
            {widget.name}
          </Menu.Item>
          <Menu.Item
            name='connectTo'
            active={activeMenu === "connectTo"}
            onClick={(e, { name }) => setActiveMenu(name)}
          >
            Connect To
          </Menu.Item>

          <Menu.Item
            name='code'
            active={activeMenu === "code"}
            onClick={(e, { name }) => setActiveMenu(name)}
          >
            Code
          </Menu.Item>
          <Menu.Item
            name='general'
            active={activeMenu === "general"}
            onClick={(e, { name }) => setActiveMenu(name)}
          >
            General Configuration
          </Menu.Item>
          <Menu.Item
            name='delete'
            active={activeMenu === "delete"}
            onClick={(e, { name }) => setActiveMenu(name)}
          >
            <b style={{ color: "red" }}>Delete</b>
          </Menu.Item>
        </Menu>
      </Grid.Column>
      <Grid.Column width={13}>
        {activeMenu === "connectTo" && (
          <ConnectTo type='script' field='connectTo' />
        )}
        {activeMenu === "code" && <ScriptForm />}
        {activeMenu === "general" && <General />}
        {activeMenu === "delete" && <DeleteForm />}
      </Grid.Column>
    </Grid>
  );
};

export default Script;
